import React from 'react'
import Button from './Button'



const ScenarioCard = ({title, number, hashtags, body, questions, imgSrc, nextStep}) => {

    const Continue = e => {
        e.preventDefault();
        nextStep();
    }


  return (
    <>
        <div className='d-flex justify-content-start ms-lg-5'>
            <Button buttonText='NYT SCENARIE' onClick={Continue}/>
        </div> 
        <div className='__scenario-card'>
            <div className='__scenario-wrapper'>
                <div className='d-flex justify-content-between'>
                    <div className='__scenario-title'>{title}</div>
                    <div className='__scenario-number'>No. {number}</div>
                </div>    
                <hr></hr>
                <div className='__scenario-hashtags'>{hashtags}</div>
                <div className='__scenario-body'>{body}</div>
                <div className='__scenario-questions'>{questions.map(x => <p key={x}>{x}</p>)}</div>
            </div>
            <div className='__img-wrapper'>
                <img src={imgSrc} alt="Scenario images" />
            </div>
        </div>

    </>

  )
}

export default ScenarioCard